import React, { useState } from "react";
import { Form, Input, DatePicker, Select, Button, Space, Row, Col } from "antd";
import { SearchOutlined, ReloadOutlined } from "@ant-design/icons";

const { RangePicker } = DatePicker;
const { Option } = Select;

// 许可申请状态选项
const PERMIT_STATUS_OPTIONS = [
    { value: "PENDING", label: "待处理" },
    { value: "APPROVED", label: "已批准" },
    { value: "REJECTED", label: "已拒绝" },
    { value: "CANCELLED", label: "已取消" },
    { value: "NULL", label: "无状态" },
];

/**
 * 许可申请筛选组件
 * @param {Object} props
 * @param {Function} props.onSearch - 搜索回调函数
 * @param {Function} props.onReset - 重置回调函数
 */
const PermitRequestFilter = ({ onSearch, onReset }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    // 处理搜索
    const handleSearch = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            
            // 处理日期范围
            if (values.dateRange && values.dateRange.length === 2) {
                values.flight_date_start = values.dateRange[0].format('YYYY-MM-DD');
                values.flight_date_end = values.dateRange[1].format('YYYY-MM-DD');
            }
            delete values.dateRange;

            // 处理状态数组
            if (values.status && values.status.length > 0) {
                values.status = values.status.join(',');
            } else {
                delete values.status;
            }

            onSearch && onSearch(values);
        } catch (error) {
            console.error('表单验证失败:', error);
        } finally {
            setLoading(false);
        }
    };

    // 处理重置
    const handleReset = () => {
        form.resetFields();
        onReset && onReset();
    };

    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSearch}
        >
            <Row gutter={[16, 8]}>
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="航班号"
                        name="flight_number"
                    >
                        <Input
                            placeholder="输入航班号"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="航班日期"
                        name="dateRange"
                    >
                        <RangePicker
                            style={{ width: '100%' }}
                            placeholder={['开始日期', '结束日期']}
                            allowClear
                        />
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="状态"
                        name="status"
                    >
                        <Select
                            mode="multiple"
                            placeholder="选择状态"
                            allowClear
                        >
                            {PERMIT_STATUS_OPTIONS.map(option => (
                                <Option key={option.value} value={option.value}>
                                    {option.label}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="出发机场"
                        name="departure_airport"
                    >
                        <Input
                            placeholder="输入机场代码"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="到达机场"
                        name="arrival_airport"
                    >
                        <Input
                            placeholder="输入机场代码"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item
                        label="批次号"
                        name="batch_id"
                    >
                        <Input
                            placeholder="输入批次号"
                            allowClear
                        />
                    </Form.Item>
                </Col>
                
                <Col xs={24} sm={12} md={8} lg={6}>
                    <Form.Item label=" " style={{ marginBottom: 0 }}>
                        <Space>
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                loading={loading}
                            >
                                搜索
                            </Button>
                            <Button
                                icon={<ReloadOutlined />}
                                onClick={handleReset}
                            >
                                重置
                            </Button>
                        </Space>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
};

export default PermitRequestFilter; 